module.exports = __webpack_public_path__ + "img/manageChannel.2ada018c.svg";